
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const HeroSection = () => {
  return (
    <header className="text-center space-y-6">
      <span className="inline-block bg-racing-accent/20 text-racing-accent text-sm font-medium px-3 py-1 rounded-full mb-4">
        How to Play
      </span>
      <motion.h1 
        className="text-4xl md:text-7xl font-black"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        
        From Stable to <span className="text-racing-accent">Stardom</span>
      </motion.h1>
      <motion.p 
        className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        Build Your Racing Empire in <b>Front Runner: Racehorse Manager</b>
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
      >
        <ChevronDown className="w-6 h-6 mx-auto text-racing-accent animate-bounce" />
      </motion.div>
    </header>
  );
};

export default HeroSection;
